module.exports = __webpack_public_path__ + "img/title.bf77995c.svg";